import {css} from 'lit';
export const styles = css`:host{display:table-row-group}`;
export default styles;
